import { observer } from 'mobx-react-lite'
import { ConstantFilter } from '@/features/legends/filters/components/ConstantFilter'
import type { ConstantEditorViewModel } from '@/features/legends/filters/types/ConstantEditorViewModel'

export interface ConstantFilterContainerProps {
  vm: ConstantEditorViewModel
  isDisabled?: boolean
  testId?: string
}

export const ConstantFilterContainer = observer(
  function ConstantFilterContainer({
    vm,
    isDisabled,
    testId,
  }: ConstantFilterContainerProps) {
    return (
      <ConstantFilter
        value={vm.value}
        onChange={vm.setValue}
        isDisabled={isDisabled}
        testId={testId && `${testId}-value`}
      />
    )
  },
)
